import { styled } from 'styled-components';

export const LoaderWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoadingImage = styled.img`
  height: 72px;
`;
